export default __webpack_public_path__ + "static/media/RequestDecline.f68795cd.svg";